export default {
    'Name': 'name',
    'Street': "street",
    'City': "city",
    'State': "state",
    'Zip Code': 'zipcode',
    'Phone': 'phone',
    'Email': 'email',
}